/* eslint-disable no-restricted-syntax */
import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0041D2",
      dark: "#002D93",
    },
    secondary: {
      main: "#616161",
      dark: "#434343",
    },
    error: {
      main: "#FF3C38", // should be #DF2E2A to match the design ff_emarketing_integration
    },
    info: {
      main: "#00D2FC",
    },
    success: {
      main: "#4BA063",
      light: "#86BF96",
    },
    warning: {
      main: "#FFCE5C",
      light: "#FFDE92",
    },
    orange: {
      main: "#E36D09",
    },
    divider: "rgb(224, 224, 224)",
    background: {
      dark: "#03193F",
      lightBlue: "#F3F7FE",
      coolBlue: "#CDDCFF", // Cool Blue
      error: "#ffebeb",
      warning: "#fff6e2",
      beta: "#E55B39",
      new: "#9C1B90",
      preview: "#474554",
      cautions: "#E53279",
      success: "#EDF6EF",
      info: "#E6FBFF",
    },
    state: {
      active: "#E0E0E0", // active item element
      hover: "#F5F5F5", // hover item element
    },
    text: {
      primary: "#212121",
    },
  },
  typography: {
    button: {
      fontWeight: "bold",
    },
    fontFamily: "Lato",
    h6: {
      fontSize: "1.15rem",
      fontWeight: "bold",
    },
    h5: {
      fontWeight: "bold",
    },
    subtitle1: {
      fontWeight: "bold",
    },
    subtitle2: {
      fontWeight: "bold",
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: "bold",
        },
        root: {
          borderBottomColor: grey[200],
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        img: {
          objectFit: "contain",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontSize: 13,
        },
        sizeMedium: {
          fontSize: 14,
        },
        sizeLarge: {
          fontSize: 15,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .Mui-disabled": {
            backgroundColor: grey[100],
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .Mui-disabled": {
            backgroundColor: grey[100],
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          "&.MuiListItemIcon-root": { minWidth: 0 },
          marginRight: 8,
        },
      },
    },
  },
});
